import { useState } from 'react';

import { cn } from '../../lib/cn';

// Sprint 10 — Slice D — Avatar con fallback de iniciales.
// Si no hay `src` (o la imagen falla al cargar), rinde un círculo con las
// iniciales del nombre. Sin dependencias nuevas.

interface AvatarProps {
  src?: string | null;
  nombre: string;
  /** Tamaño en px del círculo. */
  size?: number;
  alt?: string;
  className?: string;
}

function iniciales(nombre: string): string {
  const partes = nombre.trim().split(/\s+/).filter(Boolean);
  if (partes.length === 0) return '?';
  if (partes.length === 1) return partes[0]!.slice(0, 2).toUpperCase();
  return (partes[0]![0]! + partes[partes.length - 1]![0]!).toUpperCase();
}

export function Avatar({ src, nombre, size = 32, alt, className }: AvatarProps): JSX.Element {
  const [errored, setErrored] = useState(false);
  const showImg = src && !errored;
  const dimension = { width: size, height: size };

  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-marca-primario-oscuro/15 font-medium text-text-marca',
        className,
      )}
      style={dimension}
      aria-hidden={!alt}
    >
      {showImg ? (
        <img
          src={src}
          alt={alt ?? nombre}
          className="h-full w-full object-cover"
          style={dimension}
          onError={() => setErrored(true)}
        />
      ) : (
        <span style={{ fontSize: Math.round(size * 0.4) }}>{iniciales(nombre)}</span>
      )}
    </span>
  );
}
